/* ===== THORNWOVEN — APP (MASTER INIT) ===== */
(function () {
  'use strict';

  // ── Toast ──
  function showToast(msg) {
    var toast = document.getElementById('toast');
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    setTimeout(function () { toast.classList.remove('show'); }, 2600);
  }
  window.showToast = showToast;

  // ── Email Validation ──
  var DISPOSABLE_DOMAINS = [
    'mailinator.com', 'tempmail.com', 'temp-mail.org', 'guerrillamail.com',
    'guerrillamail.info', '10minutemail.com', 'throwawaymail.com', 'yopmail.com',
    'trashmail.com', 'sharklasers.com', 'getnada.com', 'dispostable.com',
    'maildrop.cc', 'fakeinbox.com', 'spam4.me', 'mailnesia.com', 'tempinbox.com',
    'mohmal.com', 'emailondeck.com', 'tempr.email', 'discard.email', 'mailcatch.com',
    'fakemail.net', 'tmpmail.org', 'minuteinbox.com', 'example.com', 'test.com'
  ];
  var TYPO_DOMAINS = [
    'gmail.con', 'gmail.co', 'gmail.cm', 'gmial.com', 'gmal.com', 'gmai.com',
    'gnail.com', 'gmaill.com', 'yahoo.con', 'yaho.com', 'yahooo.com',
    'hotmail.con', 'hotmai.com', 'hotmial.com', 'outlook.con', 'iclould.com',
    'icloud.con', 'aol.con'
  ];
  function isValidEmail(raw) {
    if (!raw) return false;
    var email = raw.trim().toLowerCase();
    var re = /^[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$/;
    if (!re.test(email)) return false;
    if (email.indexOf('..') !== -1) return false;
    var parts = email.split('@');
    var local = parts[0], domain = parts[1];
    if (!local || !domain) return false;
    if (local.charAt(0) === '.' || local.charAt(local.length - 1) === '.') return false;
    if (domain.charAt(0) === '.' || domain.charAt(domain.length - 1) === '.' || domain.charAt(0) === '-') return false;
    if (DISPOSABLE_DOMAINS.indexOf(domain) !== -1) return false;
    if (TYPO_DOMAINS.indexOf(domain) !== -1) return false;
    return true;
  }
  window.isValidEmail = isValidEmail;

  // ── Hamburger → Sidebar ──
  var hamburger = document.getElementById('hamburger');
  var mobileMenu = document.getElementById('mobileMenu');
  var navOverlay = document.getElementById('navOverlay');
  var navClose = document.getElementById('navSidebarClose');

  function openMenu() {
    if (hamburger) hamburger.classList.add('active');
    if (mobileMenu) mobileMenu.classList.add('open');
    if (navOverlay) navOverlay.classList.add('open');
    if (window.lockScroll) window.lockScroll();
  }
  function closeMenu() {
    if (hamburger) hamburger.classList.remove('active');
    if (mobileMenu) mobileMenu.classList.remove('open');
    if (navOverlay) navOverlay.classList.remove('open');
    if (window.unlockScroll) window.unlockScroll();
  }
  window.closeNavMenu = closeMenu;

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      if (mobileMenu.classList.contains('open')) closeMenu(); else openMenu();
    });
    if (navClose) navClose.addEventListener('click', closeMenu);
    if (navOverlay) navOverlay.addEventListener('click', closeMenu);
    document.querySelectorAll('.mobile-nav-link').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });
  }

  // ── Newsletter form: client-side email validation before native submit ──
  var newsletterForm = document.getElementById('newsletterForm');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function (e) {
      var emailInput = newsletterForm.querySelector('input[type="email"]');
      if (emailInput && !isValidEmail(emailInput.value)) {
        e.preventDefault();
        showToast('Please enter a valid email address');
        emailInput.focus();
      }
    });
  }

  // ── Marquee: items authored once; duplicate at runtime so the single
  //    translateX(-50%) track loops seamlessly (not two blocks in markup) ──
  (function () {
    var track = document.getElementById('marqueeTrack');
    if (!track || track.dataset.cloned) return;
    track.dataset.cloned = '1';
    track.innerHTML = track.innerHTML + track.innerHTML;
  })();

  // ── Rotating Announcement Bar ──
  (function () {
    var slides = document.querySelectorAll('.announcement-slide');
    if (slides.length < 2) return;
    var idx = 0;
    setInterval(function () {
      var current = slides[idx];
      var next = slides[(idx + 1) % slides.length];
      current.classList.remove('active');
      current.classList.add('exit');
      next.classList.remove('exit');
      next.classList.add('active');
      setTimeout(function () { current.classList.remove('exit'); }, 500);
      idx = (idx + 1) % slides.length;
    }, 4500);
  })();

  // ── Welcome Popup ──
  (function () {
    var overlay = document.getElementById('welcomeOverlay');
    if (!overlay) return;
    var modal = overlay.querySelector('.welcome-modal');
    var form = document.getElementById('welcomeForm');
    var phoneInput = document.getElementById('welcomePhone');
    var emailInput = document.getElementById('welcomeEmail');
    var submitBtn = document.getElementById('welcomeSubmit');
    var closeBtn = document.getElementById('welcomeClose');
    var declineBtn = document.getElementById('welcomeDecline');
    var copyBtn = document.getElementById('welcomeCopy');
    var codeEl = document.getElementById('welcomeCode');
    var SEEN_KEY = 'tw-welcome-seen';
    var delay = ((window.THEME && window.THEME.popupDelay) || 5) * 1000;

    function openPopup() { overlay.classList.add('open'); }
    function closePopup() { overlay.classList.remove('open'); localStorage.setItem(SEEN_KEY, '1'); }
    window.closeWelcomePopup = closePopup;

    if (!localStorage.getItem(SEEN_KEY)) setTimeout(openPopup, delay);

    // Submit → POST to Shopify /contact (same-origin) via hidden iframe, then show code
    function subscribe(email, phone) {
      return new Promise(function (resolve) {
        var iframe = document.createElement('iframe');
        iframe.name = 'tw-welcome-target';
        iframe.style.display = 'none';
        document.body.appendChild(iframe);

        var f = document.createElement('form');
        f.method = 'POST';
        f.action = '/contact';
        f.target = 'tw-welcome-target';
        f.acceptCharset = 'UTF-8';
        f.style.display = 'none';
        var fields = {
          form_type: 'customer', utf8: '✓',
          'contact[tags]': 'newsletter,welcome-popup',
          'contact[email]': email,
          'contact[phone]': phone || ''
        };
        Object.keys(fields).forEach(function (k) {
          var i = document.createElement('input');
          i.type = 'hidden'; i.name = k; i.value = fields[k];
          f.appendChild(i);
        });
        document.body.appendChild(f);
        var done = false;
        function cleanup() { if (done) return; done = true; try { document.body.removeChild(f); document.body.removeChild(iframe); } catch (e) {} }
        iframe.onload = function () { cleanup(); resolve(true); };
        setTimeout(function () { cleanup(); resolve(true); }, 3500);
        f.submit();
      });
    }

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = emailInput.value.trim();
      if (!isValidEmail(email)) {
        emailInput.focus();
        emailInput.style.borderColor = 'var(--rose)';
        emailInput.placeholder = 'Enter a valid email';
        return;
      }
      emailInput.style.borderColor = '';
      submitBtn.disabled = true;
      submitBtn.textContent = 'Unlocking...';
      var phone = phoneInput ? phoneInput.value.trim() : '';
      subscribe(email, phone).then(function () {
        localStorage.setItem(SEEN_KEY, '1');
        modal.classList.add('success');
      });
    });

    if (copyBtn && codeEl) copyBtn.addEventListener('click', function () {
      var code = codeEl.textContent.trim();
      if (navigator.clipboard) { navigator.clipboard.writeText(code).catch(function () {}); }
      copyBtn.textContent = 'Copied ✓';
      copyBtn.classList.add('copied');
      setTimeout(function () { copyBtn.textContent = 'Copy Code'; copyBtn.classList.remove('copied'); }, 2000);
    });

    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (declineBtn) declineBtn.addEventListener('click', closePopup);
    // Background clicks no longer dismiss the popup — only the X or "No thanks"
    // link closes it, so it can't be closed accidentally. People exit when they choose.
  })();

  // ── FAQ accordion ──
  (function () {
    var qs = document.querySelectorAll('.faq-q');
    if (!qs.length) return;
    qs.forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.closest('.faq-item');
        var isOpen = item.classList.toggle('open');
        q.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  })();

  // ── Reveal on scroll (policy / generic pages) ──
  (function () {
    var reveals = document.querySelectorAll('.reveal');
    if (!reveals.length) return;
    if (!('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.1 });
    reveals.forEach(function (el) { io.observe(el); });
  })();

  // ── ESC closes modals ──
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var welcome = document.getElementById('welcomeOverlay');
    var sizeGuide = document.getElementById('sizeGuideOverlay');
    var productModal = document.getElementById('productModal');
    var cartDrawer = document.getElementById('cartDrawer');
    var sidebar = document.getElementById('mobileMenu');
    if (welcome && welcome.classList.contains('open')) window.closeWelcomePopup && window.closeWelcomePopup();
    else if (sizeGuide && sizeGuide.classList.contains('open')) window.closeSizeGuide && window.closeSizeGuide();
    else if (productModal && productModal.classList.contains('open')) window.closeModal && window.closeModal();
    else if (cartDrawer && cartDrawer.classList.contains('open')) window.closeCart && window.closeCart();
    else if (sidebar && sidebar.classList.contains('open')) window.closeNavMenu && window.closeNavMenu();
  });
})();
